import { useState } from 'react';
import { ArrowLeft, CalendarX, Check } from 'lucide-react';
import {
  coverageEndsOn,
  CANCELLATION_REASONS,
  LABEL,
  OUTLINE_PLAN_BTN,
} from './helper';

const Reason = ({ label, checked, disabled, onSelect }) => (
  <label
    className={`flex items-center gap-3 rounded-xl border p-3.5 transition-colors ${
      checked ? 'border-teamcare-blue bg-blue-50/50' : 'border-secondary-200 bg-white'
    } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:border-secondary-300'}`}
  >
    <input
      type="radio"
      name="cancellation_reason"
      className="sr-only"
      checked={checked}
      disabled={disabled}
      onChange={onSelect}
    />
    <span
      aria-hidden
      className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
        checked ? 'border-teamcare-blue bg-teamcare-blue text-white' : 'border-secondary-300 bg-white'
      }`}
    >
      {checked && <Check size={12} strokeWidth={3.5} />}
    </span>

    <span className="min-w-0 flex-1 text-sm font-semibold text-secondary-900">{label}</span>
  </label>
);

const CancelMembership = ({ enrollment, onConfirm, onBack, busy = false }) => {
  const [reason, setReason] = useState(null);
  const endsOn = coverageEndsOn(enrollment);

  return (
    <div className="animate-slide-up">
      <div className="mb-5 flex items-start gap-4 rounded-xl border border-gray-200 bg-secondary-50/60 p-4">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-amber-100 bg-white text-amber-600">
          <CalendarX size={20} />
        </span>
        <div className="min-w-0">
          <p className="text-[15px] font-bold text-secondary-900">Ask to cancel your membership?</p>
          <p className="mt-1 text-xs leading-relaxed text-secondary-500">
            The practice handles cancellations, so this sends them a request rather than ending
            anything today. Your {enrollment?.plan_name} benefits carry on while they look at it, and
            they'll either let your cover run to {endsOn ? <strong>{endsOn}</strong> : 'the end of this period'}
            {' '}or end it sooner and refund the part you haven't used.
          </p>
        </div>
      </div>

      <p className={LABEL}>Why are you leaving?</p>
      <div className="mt-2 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
        {CANCELLATION_REASONS.map(({ key, label }) => (
          <Reason
            key={key}
            label={label}
            checked={key === reason}
            disabled={busy}
            onSelect={() => setReason(key)}
          />
        ))}
      </div>

      <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <button
          type="button"
          onClick={onBack}
          disabled={busy}
          className={`${OUTLINE_PLAN_BTN} shrink-0 gap-2 px-4 disabled:opacity-50`}
        >
          <ArrowLeft size={15} />
          Keep my membership
        </button>

        <button
          type="button"
          onClick={() => onConfirm(reason)}
          disabled={busy || !reason}
          className="btn h-11 min-h-11 shrink-0 gap-2 rounded-xl border-0 bg-red-600 px-5 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-50"
        >
          {busy ? 'Sending…' : 'Send cancellation request'}
        </button>
      </div>
    </div>
  );
};

export default CancelMembership;
